"use strict";
exports.__esModule = true;
exports.IconButtonWithText = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var react_1 = tslib_1.__importDefault(require("react"));
var Icon_1 = require("../Icon");
var Typography_1 = require("../Typography");
var useClasses = function (hoverable, color) {
    return core_1.makeStyles(function (theme) {
        var _a, _b, _c, _d, _e;
        return core_1.createStyles({
            container: {
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                width: 'fit-content',
                padding: hoverable ? '8px 12px' : 0,
                transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                borderRadius: 6,
                '&:hover': {
                    backgroundColor: hoverable ? (_a = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _a === void 0 ? void 0 : _a.grey[30] : 'transparent'
                }
            },
            iconContainer: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 24,
                height: 24,
                borderRadius: '50%',
                background: color === 'primary'
                    ? (_c = (_b = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _b === void 0 ? void 0 : _b.primary) === null || _c === void 0 ? void 0 : _c.main : (_e = (_d = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _d === void 0 ? void 0 : _d.secondary) === null || _e === void 0 ? void 0 : _e.main
            },
            marginLeft: {
                marginLeft: 10
            },
            marginRight: {
                marginRight: 10
            },
            icon: {
                fontSize: '18px !important',
                color: 'white'
            },
            text: {
                fontWeight: 600
            }
        });
    });
};
var IconButtonWithText = function (_a) {
    var children = _a.children, _b = _a.hoverable, hoverable = _b === void 0 ? true : _b, _c = _a.color, color = _c === void 0 ? 'primary' : _c, iconContainerProps = _a.iconContainerProps, iconProps = _a.iconProps, rest = tslib_1.__rest(_a, ["children", "hoverable", "color", "iconContainerProps", "iconProps"]);
    var classes = useClasses(hoverable, color)();
    return (react_1["default"].createElement("div", tslib_1.__assign({ className: classes.container }, rest),
        react_1["default"].createElement("div", tslib_1.__assign({ className: classes.iconContainer + " " + classes.marginRight + " " + (iconContainerProps === null || iconContainerProps === void 0 ? void 0 : iconContainerProps.className) }, iconContainerProps),
            react_1["default"].createElement(Icon_1.Icon, tslib_1.__assign({ classes: { root: classes.icon }, name: "add" }, iconProps))),
        react_1["default"].createElement(Typography_1.BodyText, { classes: { root: classes.text } }, children)));
};
exports.IconButtonWithText = IconButtonWithText;
//# sourceMappingURL=IconButtonWithText.js.map